import { runtimeConfig } from "@src/runtime-config";

/** List all the main routes that user can navigate */
export enum MainRoutes {
  /** The root page of the app which will be redirected to app route */
  root = "/",

  /** Login page */
  login = "login",

  /** Custom Single Sign-On (SSO) login page */
  ssoLogin = "sso-login",

  /** Page to login with one of the available authentication providers */
  providerLogin = "provider-login",

  /** Logout page */
  logout = "logout",

  /** Signup page */
  signup = "signup",

  /** Email verification page */
  verifyEmail = "verifymail",

  /** Resend verification email page */
  resendEmail = "resendEmail",

  /** Password recovery page */
  passwordRecovery = "passwordRecovery",

  /** Reset Password page */
  resetPassword = "resetPassword",

  /** Complete Account information page */
  completeAccount = "completeAccount",

  /** Login redirect route for the Connect App */
  connectLoginRedirect = "connect-login-redirect",

  /** Redirection from the user module */
  userModule = "user-module",

  /** Old dashboard login route from legacy UserModule to be redirected to the new login route */
  oldDashboardLogin = "dashboard-login",

  /** Legal pages such as terms of service, privacy policy, etc */
  legal = "legal",

  /** Redirection of WebEditor links to the Sphere Viewer, prefixing a WebEditor path */
  webEditorLink = "web-editor-link",

  /** Redirection of Sphere Viewer views back to the WebEditor, prefixing a viewer path */
  viewerLink = "viewer-link",
}

/** List of routes under signup regarding how user account can be created */
export enum SignUpRoutes {
  /** Sign up flow for a user who is invited to join a workspace */
  invited = "invited",

  /** Sign up flow for a user who wants to start a free trial */
  trial = "trial",
}

/** All the query  params that can be appended to the route */
export enum QueryParams {
  /** ID of the client App that uses the ULM */
  client = "client",

  /** Version of the client App that uses the ULM */
  version = "version",

  /** Encoded window parent URL when the ULM is embedded. It is only used by the Sphere Dashboard */
  parentUrl = "parent_url",

  /** Trial type identifier that can be used to request a trial with specific features */
  trialType = "trialType",

  /** Redirect URL. This query param can be used for general purposes */
  redirectUrl = "redirectUrl",

  /** Redirect URL after a successful Sphere 2 COM login */
  redirectUrlS2Com = "redirectUrlS2Com",

  /** Redirect URL after a successful Sphere 2 EU login */
  redirectUrlS2Eu = "redirectUrlS2Eu",

  /** Use to hide the `Get started` text and link from the ULM login page */
  hideRegistration = "hideRegistration",

  /** Email to prefill the email input. If passed the ULM will request the email servers automatically */
  email = "email",

  /** Available server option. If passed this will be the only available server options */
  server = "server",

  /** Preselect server. If passed and if the user has active account there, it will automatically select that server */
  preselectedServer = "preselectedServer",

  /** Company name used when a user invited to a company or Company Single Sign-On (SSO) ID */
  company = "company",

  /** Key used to verify the user email address */
  key = "key",

  /** Oauth provider selected by the user during registration */
  provider = "provider",

  /** Comma-separated list of oauth provider options */
  providers = "providers",

  /** Query parameter to set the language */
  lang = "lang",
}

/** All the legal redirects such as terms of service, privacy policy, etc */
export const legalRedirects: Record<
  string,
  { path: string; targetUrl: string }
> = {
  termsOfService: {
    path: "terms-of-service",
    targetUrl: runtimeConfig.urls.termsOfServiceUrl,
  },
  privacyPolicy: {
    path: "privacy-policy",
    targetUrl: runtimeConfig.urls.privacyPolicyUrl,
  },
  dataProcessingAgreement: {
    path: "data-processing-agreement",
    targetUrl: runtimeConfig.urls.dataProcessingAgreementUrl,
  },
  cookiePolicy: {
    path: "cookie-policy",
    targetUrl: runtimeConfig.urls.cookiePolicyUrl,
  },
};
